import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
@Injectable({
  providedIn: 'root'
})
export class UserService {


  constructor(private http: HttpClient, private authService: AuthenticationService) {
  }

  update(profilePayLoad) {
    return this.http.post<any>(environment.apiUrl + '/profile', profilePayLoad).pipe(
      map(response => {
        if (response.error) {
          return response;
        }
        this.authService.updateLoginStorage(response.data);
        return response;
      }));
  }

}
